import Vue from "vue";
import axios from "axios"
import route from "@main/config/routes.js"
import {installSliderType7} from "@main/components/sliders/type7"
import scrollAppearance from "./scroll-appearance"
import paramHeight from "./param-height"
import {formMethod} from "../../helpers"


const $modal = $(".js-modal-alert"),
    $compareCountNode = $(".js-compare-count");

if($("#js-vue-page-comparison").length > 0){

    new Vue({
        el: "#js-vue-page-comparison",
        components: {},
        data: {
            cards: [],
            all: true,
            loaded: false,
        },
        created(){

            this.getCards();
        },
        methods: {
            getCards(){

                const t = this;

                axios({
                    url: route.pageCompare,
                    params: {
                        all: this.all,
                    },
                    method: "get",
                    headers: {"Content-Type": "application/json"},
                }).then((res) => {

                    if(res.data.success){

                        this.cards = res.data.data;

                        setTimeout(function(){
                            t.loaded = true;
                            t.redrawing();
                        },);

                    }else{

                        $modal.find (".js-modal-title").html();
                        $modal.find (".js-modal-text").html(res.data.message);
                        $modal.addClass("fade-in opened")
                            .removeClass("fade-out");
                    }
                }).catch(() => {
                    alert("Что-то пошло не так...\nПопробуйте обновить страницу");
                });
            },
            changeFilter(isAll){

                this.all = isAll;
                this.getCards();
            },
            remove(e, i){

                e.preventDefault();

                axios({
                    url: route.compareProducts,
                    data: {
                        id: this.cards[i].id,
                        isChecked: false,
                    },
                    method: formMethod("post"),
                    headers: {"Content-Type": "application/json"},
                }).then((res) => {

                    if(res.data.success){

                        this.cards.splice(i ,1);
                        $(".js-slider-type7").trigger("destroy.owl.carousel");
                        this.redrawing();

                        if(this.cards.length > 0){
                            $compareCountNode.closest(".compare-wrap").show();
                        }else{
                            $compareCountNode.closest(".compare-wrap").hide();
                        }

                        $compareCountNode.text(this.cards.length);

                    }else{
                        $modal.find (".js-modal-title").html();
                        $modal.find (".js-modal-text").html(res.data.message);
                        $modal.addClass("fade-in opened")
                            .removeClass("fade-out");
                    }
                }).catch(() => {
                    alert("Что-то пошло не так...\nПопробуйте обновить страницу");
                });
            },
            clear(){

                axios({
                    url: route.clearCompareProducts,
                    data: {},
                    method: formMethod("post"),
                    headers: {"Content-Type": "application/json"},
                }).then((res) => {
                    if(res.data.success){

                        this.cards = [];
                        $compareCountNode.closest(".compare-wrap").hide();
                        $compareCountNode.text(0);
                    }else{
                        $modal.find (".js-modal-title").html();
                        $modal.find (".js-modal-text").html(res.data.message);
                        $modal.addClass("fade-in opened")
                            .removeClass("fade-out");
                    }
                }).catch(() => {
                    alert("Что-то пошло не так...\nПопробуйте обновить страницу");
                });
            },
            redrawing(){

                setTimeout(function(){
                    installSliderType7();
                    scrollAppearance();
                    paramHeight();
                },0);
            },
        },
    });
}



